
import { defineComponent, PropType } from 'vue';

// The envelope and chat icons of the notification designs. The design uses each
// one at two sizes and in two colours, so the drawing is a single file used as a
// mask: the size comes from the parent's width and height, the colour from its
// `color`.
export default defineComponent({
    name: 'VirtualRedTagMethodIcon',
    props: {
        method: {
            type: String as PropType<'email' | 'text'>,
            required: true,
        },
    },
});
